// extracted by mini-css-extract-plugin
module.exports = {"untilText":"az_fSc","closeText":"az_gSc"};